// extracted by mini-css-extract-plugin
export default {"policy":"Policy_policy__MhDFb","lettered":"Policy_lettered__pBlt+","top-level":"Policy_top-level__XuhQ9"};